import {
  SHTable,
  SHTableBody,
  SHTableCell,
  SHTableContainer,
  SHTableHead,
  SHTableRow,
} from "@components/design-systems";
import SHSkeleton from "@components/design-systems/sh-skeleton";
import React from "react";
import { useTheme } from "@mui/material";

export const TableSkeleton = () => {
  const { palette } = useTheme();

  return (
    <SHTableContainer sx={{ paddingBottom: 2 }}>
      <SHTable>
        <SHTableHead>
          <SHTableRow>
            {Array.from(Array(5).keys()).map((_, index) => {
              return (
                <SHTableCell key={index}>
                  <SHSkeleton
                    delay={false}
                    variant="text"
                    width={100}
                    height={20}
                  />
                </SHTableCell>
              );
            })}
          </SHTableRow>
        </SHTableHead>

        <SHTableBody>
          {Array.from(Array(6).keys()).map((_, i) => {
            return (
              <SHTableRow
                key={i}
                sx={{
                  borderLeftWidth: 1,
                  borderRightWidth: 1,
                  borderTopWidth: i !== 0 ? 0 : 1,
                  backgroundColor:
                    i % 2 === 0
                      ? `${palette.secondary[50]} !important`
                      : "transparent !important",
                  td: { overflow: "hidden" },
                }}
              >
                {Array.from(Array(5).keys()).map((_, index) => {
                  return (
                    <SHTableCell key={index}>
                      <SHSkeleton
                        delay={false}
                        variant="text"
                        width={140}
                        height={40}
                      />
                    </SHTableCell>
                  );
                })}
              </SHTableRow>
            );
          })}
        </SHTableBody>
      </SHTable>
    </SHTableContainer>
  );
};
